export const MODE = process.env.NODE_MODE

// export const PROTOCOL = MODE === 'prod' ? 'https:' : 'http:';
let PROTOCOL = ''
let host = ''
if (process.browser) {
  PROTOCOL = window.location.protocol
  host = window.location.host.replace('www', '').replace('app', '')
}
if (typeof window !== 'undefined') {
  PROTOCOL = window.location.protocol
  host = window.location.host.replace('www', '').replace('app', '')
}

export const BASEURL = host.includes('localhost') || host.includes('127.0.0.1') ? '' : PROTOCOL + '//gateway' + host

// 环境变量相关配置
export const MODE_CONF = {
  development: {
    base_url: BASEURL,
    redirectUrl: 'http://m.dev.eline56-inc.com/'
  },
  dev: {
    base_url: BASEURL,
    redirectUrl: 'http://m.dev.eline56-inc.com/'
  },
  test: {
    base_url: BASEURL,
    redirectUrl: 'http://m.test.eline56-inc.com/'
  },
  prepub: {
    base_url: BASEURL,
    redirectUrl: 'http://m.prepub.eline56-inc.com/'
  },
  prod: {
    base_url: BASEURL,
    redirectUrl: 'http://m.eline56.com/'
  }
}[MODE]

// 跳转地址
export const redirectUrl = 'http://m.test.eline56-inc.com/'
// oss地址
export const ossUrl = 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com'

//  uifox官网
export const toUifoxDownload = () => {
  window.open('https://uifox.com.cn/#/?type=contact')
}
// 问卷星
export const toWjx = () => {
  window.open('https://www.wjx.top/vj/wqkJT7s.aspx')
}

// 唤起qq
export const toServiceQQ = () => {
  window.open('https://wpa1.qq.com/yGWcFLfo?_type=wpa&qidian=true')
}

// 含有落地页的地址
export const hasBottomUrls = {
  '/em': {
    login: '/em',
    notLogin: '/introduce/emAndAci'
  },
  '/afr': {
    login: '/afr',
    notLogin: '/introduce/afr'
  },
  '/isf': {
    login: '/isf',
    notLogin: '/introduce/isf'
  },
  '/vgm': {
    login: '/vgm',
    notLogin: '/introduce/vgm'
  },
  '/ams': {
    login: '/ams',
    notLogin: '/introduce/ams'
  },
  '/ics': {
    login: '/ics',
    notLogin: '/introduce/ics'
  },
  '/cps': {
    login: '/cps',
    notLogin: '/introduce/cps'
  },
  '/cpsqd': {
    login: '/cpsqd',
    notLogin: '/introduce/cpsqd'
  },
  '/track': {
    login: '/track',
    notLogin: '/introduce/track'
  },
  '/track/fullLink': {
    login: '/track/fullLink',
    notLogin: '/introduce/track'
  },
  '/CSP': {
    login: '/track/pushSubscriptions',
    notLogin: '/introduce/track'
  },
  '/freight': {
    login: '/freight',
    notLogin: '/introduce/shipping'
  },
  '/booking': {
    login: '/booking',
    notLogin: '/introduce/booking'
  },
  '/shipping': {
    login: '/track/schedule',
    notLogin: '/introduce/shipping'
  },
  '/accurate': {
    login: '/track/accurate',
    notLogin: '/introduce/shipping'
  }
}

// 枚举：判断是否开通产品的code
export const _ENUM_CODE = {
  VGM: 'vgm',
  SHCPS: 'shcps',
  QDCPS: 'qdcps',
  SHTRACK: 'shTrack',
  SZTRACK: 'szTrack',
  NBTRACK: 'nbTrack',
  SCHEDULE: 'ship',
  AMS: 'ams',
  EM: 'em',
  ACI: 'aci',
  AFR: 'afr',
  ICS: 'ics',
  AGENT: 'agent',
  ROB: 'rob' // 抢舱
}

// 不需要企业认证的产品 （首页用）
export const notNeedCompany = ['/track', '/track/fullLink', '/freight', '/shipping', '/accurate']
// 不需要企业认证的产品 （落地页用）
export const notNeedCompanyRouteName = ['rpa', 'track', 'shipping']

export const toHref = href => {
  return () => {
    location.href = href
  }
}
